import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Language.css';

const LANGUAGES_DATA = [
  { id: 'en', label: 'ENGLISH', native: 'ENGLISH', color: '#E8F7FF' },
  { id: 'hi', label: 'HINDI', native: 'हिंदी', color: '#FFF0F7' },
  { id: 'mr', label: 'MARATHI', native: 'मराठी', color: '#FFF1E8' },
  { id: 'te', label: 'TELUGU', native: 'తెలుగు', color: '#ECFFF1' },
  { id: 'ml', label: 'MALAYALAM', native: 'മലയാളം', color: '#FFFCE8' },
  { id: 'kn', label: 'KANNADA', native: 'ಕನ್ನಡ', color: '#EAFBFF' },
  { id: 'ta', label: 'TAMIL', native: 'தமிழ்', color: '#F5EDFF' },
  { id: 'bn', label: 'BENGALI', native: 'বাংলা', color: '#FFFCE8' }
];

const STATES = {
  Andhra_Pradesh: [
    'Visakhapatnam',
    'Vijayawada',
    'Guntur',
    'Nellore',
    'Kurnool',
    'Rajahmundry',
    'Tirupati',
    'Kakinada',
    'Kadapa',
    'Anantapur'
  ],

  Arunachal_Pradesh: [
    'Itanagar',
    'Naharlagun',
    'Tawang',
    'Pasighat',
    'Ziro',
    'Bomdila',
    'Tezu',
    'Along',
    'Daporijo',
    'Roing'
  ],

  Assam: [
    'Guwahati',
    'Dibrugarh',
    'Silchar',
    'Jorhat',
    'Nagaon',
    'Tinsukia',
    'Tezpur',
    'Sivasagar',
    'Dhubri',
    'Diphu'
  ],

  Bihar: [
    'Patna',
    'Gaya',
    'Bhagalpur',
    'Muzaffarpur',
    'Purnia',
    'Darbhanga',
    'Bihar Sharif',
    'Arrah',
    'Begusarai',
    'Katihar'
  ],

  Chhattisgarh: [
    'Raipur',
    'Bhilai',
    'Bilaspur',
    'Korba',
    'Durg',
    'Rajnandgaon',
    'Jagdalpur',
    'Raigarh',
    'Ambikapur',
    'Dhamtari'
  ],

  Delhi: [
    'New Delhi',
    'Delhi'
  ],

  Goa: [
    'Panaji',
    'Vasco da Gama',
    'Margao',
    'Mapusa',
    'Ponda',
    'Bicholim',
    'Curchorem',
    'Canacona'
  ],

  Gujarat: [
    'Ahmedabad',
    'Surat',
    'Vadodara',
    'Rajkot',
    'Bhavnagar',
    'Jamnagar',
    'Junagadh',
    'Gandhinagar',
    'Anand',
    'Bharuch',
    'Navsari',
    'Valsad',
    'Morbi',
    'Mehsana',
    'Palanpur'
  ],

  Haryana: [
    'Gurugram',
    'Faridabad',
    'Panipat',
    'Ambala',
    'Yamunanagar',
    'Rohtak',
    'Hisar',
    'Karnal',
    'Sonipat',
    'Panchkula',
    'Bhiwani',
    'Sirsa',
    'Rewari',
    'Fatehabad'
  ],

  Himachal_Pradesh: [
    'Shimla',
    'Dharamshala',
    'Mandi',
    'Solan',
    'Kullu',
    'Manali',
    'Baddi',
    'Una',
    'Hamirpur',
    'Bilaspur',
    'Chamba',
    'Nahan'
  ],

  Jharkhand: [
    'Ranchi',
    'Jamshedpur',
    'Dhanbad',
    'Bokaro Steel City',
    'Deoghar',
    'Hazaribagh',
    'Giridih',
    'Ramgarh',
    'Phusro',
    'Medininagar',
    'Chaibasa'
  ],

  Karnataka: [
    'Bengaluru',
    'Mysuru',
    'Hubballi',
    'Mangaluru',
    'Belagavi',
    'Kalaburagi',
    'Davanagere',
    'Ballari',
    'Shivamogga',
    'Tumakuru',
    'Udupi',
    'Vijayapura',
    'Hassan',
    'Raichur',
    'Bidar'
  ],

  Kerala: [
    'Thiruvananthapuram',
    'Kochi',
    'Kozhikode',
    'Kollam',
    'Thrissur',
    'Kannur',
    'Alappuzha',
    'Palakkad',
    'Kottayam',
    'Malappuram',
    'Kasaragod',
    'Idukki'
  ],

  Madhya_Pradesh: [
    'Bhopal',
    'Indore',
    'Jabalpur',
    'Gwalior',
    'Ujjain',
    'Sagar',
    'Dewas',
    'Satna',
    'Ratlam',
    'Rewa',
    'Burhanpur',
    'Khandwa',
    'Morena',
    'Chhindwara',
    'Shivpuri'
  ],

  Maharashtra: [
    'Mumbai',
    'Pune',
    'Nagpur',
    'Nashik',
    'Chhatrapati Sambhajinagar',
    'Thane',
    'Navi Mumbai',
    'Kalyan-Dombivli',
    'Vasai-Virar',
    'Amravati',
    'Kolhapur',
    'Solapur',
    'Nanded',
    'Sangli',
    'Jalgaon',
    'Akola',
    'Latur',
    'Dhule',
    'Ahmednagar',
    'Chandrapur',
    'Satara',
    'Ratnagiri',
    'Wardha',
    'Bhandara',
    'Yavatmal',
    'Gondia',
    'Beed',
    'Parbhani'
  ],

  Manipur: [
    'Imphal',
    'Thoubal',
    'Bishnupur',
    'Churachandpur',
    'Ukhrul',
    'Senapati',
    'Kakching',
    'Jiribam'
  ],

  Meghalaya: [
    'Shillong',
    'Tura',
    'Jowai',
    'Nongpoh',
    'Nongstoin',
    'Williamnagar',
    'Baghmara'
  ],

  Mizoram: [
    'Aizawl',
    'Lunglei',
    'Champhai',
    'Kolasib',
    'Serchhip',
    'Lawngtlai',
    'Mamit',
    'Saiha'
  ],

  Nagaland: [
    'Kohima',
    'Dimapur',
    'Mokokchung',
    'Tuensang',
    'Wokha',
    'Mon',
    'Zunheboto',
    'Phek'
  ],

  Odisha: [
    'Bhubaneswar',
    'Cuttack',
    'Rourkela',
    'Brahmapur',
    'Sambalpur',
    'Puri',
    'Balasore',
    'Baripada',
    'Jharsuguda',
    'Bhadrak',
    'Angul',
    'Dhenkanal',
    'Koraput',
    'Rayagada'
  ],

  Punjab: [
    'Ludhiana',
    'Amritsar',
    'Jalandhar',
    'Patiala',
    'Bathinda',
    'Mohali',
    'Pathankot',
    'Hoshiarpur',
    'Batala',
    'Moga',
    'Firozpur',
    'Kapurthala'
  ],

  Rajasthan: [
    'Jaipur',
    'Jodhpur',
    'Udaipur',
    'Kota',
    'Bikaner',
    'Ajmer',
    'Bharatpur',
    'Alwar',
    'Bhilwara',
    'Sikar',
    'Sri Ganganagar',
    'Pali',
    'Kishangarh',
    'Chittorgarh',
    'Barmer',
    'Jaisalmer'
  ],

  Sikkim: [
    'Gangtok',
    'Namchi',
    'Gyalshing',
    'Mangan',
    'Ravangla',
    'Singtam',
    'Jorethang'
  ],

  Tamil_Nadu: [
    'Chennai',
    'Coimbatore',
    'Madurai',
    'Tiruchirappalli',
    'Salem',
    'Tiruppur',
    'Erode',
    'Tirunelveli',
    'Vellore',
    'Thoothukudi',
    'Dindigul',
    'Thanjavur',
    'Nagercoil',
    'Kanchipuram',
    'Hosur',
    'Cuddalore',
    'Karur',
    'Namakkal'
  ],

  Telangana: [
    'Hyderabad',
    'Warangal',
    'Nizamabad',
    'Karimnagar',
    'Khammam',
    'Ramagundam',
    'Mahbubnagar',
    'Nalgonda',
    'Adilabad',
    'Suryapet',
    'Siddipet',
    'Mancherial'
  ],

  Tripura: [
    'Agartala',
    'Dharmanagar',
    'Udaipur',
    'Kailashahar',
    'Belonia',
    'Khowai',
    'Ambassa',
    'Teliamura'
  ],

  Uttar_Pradesh: [
    'Lucknow',
    'Kanpur',
    'Ghaziabad',
    'Agra',
    'Varanasi',
    'Prayagraj',
    'Meerut',
    'Noida',
    'Bareilly',
    'Aligarh',
    'Moradabad',
    'Saharanpur',
    'Gorakhpur',
    'Firozabad',
    'Jhansi',
    'Mathura',
    'Ayodhya',
    'Muzaffarnagar',
    'Rampur',
    'Hapur'
  ],

  Uttarakhand: [
    'Dehradun',
    'Haridwar',
    'Rishikesh',
    'Haldwani',
    'Roorkee',
    'Rudrapur',
    'Kashipur',
    'Nainital',
    'Almora',
    'Pithoragarh',
    'Mussoorie',
    'Kotdwar'
  ],

  West_Bengal: [
    'Kolkata',
    'Howrah',
    'Durgapur',
    'Asansol',
    'Siliguri',
    'Darjeeling',
    'Kharagpur',
    'Haldia',
    'Malda',
    'Bardhaman',
    'Berhampore',
    'Jalpaiguri',
    'Raiganj',
    'Cooch Behar'
  ]
};

export default function Language() {

  const navigate = useNavigate();

  const [selectedLanguage, setSelectedLanguage] =
    useState(LANGUAGES_DATA[0]);

  const [selectedState, setSelectedState] =
    useState('');

  const [selectedCity, setSelectedCity] =
    useState('');

  const [isPopupOpen, setIsPopupOpen] =
    useState(false);

  const [loading, setLoading] =
    useState(false);


  // =====================================================
  // LANGUAGE SELECT
  // =====================================================

  const handleSelectLanguage = (langItem) => {

    setSelectedLanguage(langItem);
    setIsPopupOpen(false);

  };


  // =====================================================
  // STATE CHANGE
  // =====================================================

  const handleStateChange = (e) => {

    setSelectedState(e.target.value);

    setSelectedCity('');

  };


  // =====================================================
  // SAVE LANGUAGE + STATE + CITY
  // =====================================================

  const handleSave = async (e) => {

    e.preventDefault();


    // Required check
    if (!selectedLanguage) {

      alert("Please select language.");

      return;
    }


    if (!selectedState) {

      alert("Please select state.");

      return;
    }


    if (!selectedCity) {

      alert("Please select city.");

      return;
    }


    // Prevent double click
    if (loading) {
      return;
    }


    setLoading(true);


    try {

      // =================================================
      // Get user ID from localStorage
      // =================================================

      const userId =
        localStorage.getItem("user_id");


      // =================================================
      // Get device UUID
      // =================================================

      const deviceUUID =
        localStorage.getItem("device_uuid");


      if (!userId && !deviceUUID) {

        alert(
          "User/device information not found. Please restart onboarding."
        );

        setLoading(false);

        return;
      }


      // =================================================
      // API CALL
      // =================================================

      const response = await fetch(
        "https://coinyoco.world/brobizee-api/update_user.php",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify({

            user_id: userId,

            device_uuid: deviceUUID,

            language: selectedLanguage.label,

            state: selectedState,

            city: selectedCity

          })
        }
      );


      // =================================================
      // HTTP CHECK
      // =================================================

      if (!response.ok) {

        throw new Error(
          `HTTP Error: ${response.status}`
        );
      }


      // =================================================
      // JSON RESPONSE
      // =================================================

      const result = await response.json();


      console.log(
        "Language API Response:",
        result
      );


      // =================================================
      // SUCCESS
      // =================================================

      if (result.success) {

        // User ID update/save
        if (result.user_id) {

          localStorage.setItem(
            "user_id",
            String(result.user_id)
          );

        }


        // Next page
        navigate("/mobilenumber");

      } else {

        alert(
          result.message ||
          "Data save nahi hua."
        );

      }

    } catch (error) {

      console.error(
        "Language API Error:",
        error
      );

      alert(
        "Server se connection nahi ho raha."
      );

    } finally {

      setLoading(false);

    }
  };


  // =====================================================
  // DOT / UI
  // =====================================================

  return (
    <div className="language-page-wrapper">

      <div className="language-app-card">

        {/* Background Decorations */}

        <div className="ambient ambient-one"></div>
        <div className="ambient ambient-two"></div>
        <div className="ambient ambient-three"></div>


        {/* Header */}

        <header className="language-header">

          <button
            type="button"
            className="back-btn"
            aria-label="Go Back"
            onClick={() => navigate(-1)}
          >

            <svg
              width="19"
              height="19"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M15 18l-6-6 6-6" />
            </svg>

          </button>


          <div className="header-status">

            <span className="status-dot"></span>

            BroBizee

          </div>

        </header>


        {/* Main Content */}

        <main className="language-content">

          <div className="welcome-badge">

            <span>✦</span>

            Personalize your experience

          </div>


          <h1 className="language-title">

            Choose your
            <span> language</span>

          </h1>


          <p className="language-subtitle">

            Select your preferred language and location
            to continue with BroBizee.

          </p>


          {/* Language Selector */}

          <button
            type="button"
            className="language-selector"
            onClick={() => setIsPopupOpen(true)}
          >

            <div className="language-icon">

              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >

                <circle cx="12" cy="12" r="9" />

                <path d="M3 12h18" />

                <path d="M12 3c2.2 2.4 3.4 5.4 3.4 9S14.2 18.6 12 21" />

                <path d="M12 3c-2.2 2.4-3.4 5.4-3.4 9S9.8 18.6 12 21" />

              </svg>

            </div>


            <div className="language-selector-text">

              <small>LANGUAGE</small>

              <strong>
                {selectedLanguage.label}
              </strong>

            </div>


            <div className="selector-arrow">

              <svg
                width="17"
                height="17"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >

                <path d="M9 18l6-6-6-6" />

              </svg>

            </div>

          </button>


          {/* Location Form */}

          <form
            onSubmit={handleSave}
            className="location-form"
          >

            {/* State */}

            <div className="input-group">

              <label htmlFor="state-select">
                State
              </label>

              <div className="select-wrapper">

                <select
                  id="state-select"
                  value={selectedState}
                  onChange={handleStateChange}
                >

                  <option value="">
                    Select your state
                  </option>

                  {Object.keys(STATES).map((state) => (

                    <option
                      key={state}
                      value={state}
                    >
                      {state}
                    </option>

                  ))}

                </select>


                <span className="custom-arrow">

                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >

                    <path d="M6 9l6 6 6-6" />

                  </svg>

                </span>

              </div>

            </div>


            {/* City */}

            <div className="input-group">

              <label htmlFor="city-select">
                City
              </label>

              <div className="select-wrapper">

                <select
                  id="city-select"
                  value={selectedCity}
                  onChange={(e) =>
                    setSelectedCity(e.target.value)
                  }
                  disabled={!selectedState}
                >

                  <option value="">

                    {selectedState
                      ? 'Select your city'
                      : 'Select state first'}

                  </option>


                  {selectedState &&
                    STATES[selectedState].map((city) => (

                      <option
                        key={city}
                        value={city}
                      >
                        {city}
                      </option>

                    ))}

                </select>


                <span className="custom-arrow">

                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >

                    <path d="M6 9l6 6 6-6" />

                  </svg>

                </span>

              </div>

            </div>



            {/* Continue Button */}

<button
  type="submit"
  className={`save-btn ${
    selectedState && selectedCity && !loading
      ? 'save-btn-active'
      : ''
  }`}
  disabled={
    !selectedState ||
    !selectedCity ||
    loading
  }
>
  <span>
    {loading
      ? "Saving..."
      : "Continue"}
  </span>

  <div className="save-arrow">
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14" />
      <path d="M13 6l6 6-6 6" />
    </svg>
  </div>
</button>

          </form>

        </main>


        {/* Footer */}

        <footer className="language-footer">

          <img
            src="/images/logo.png"
            alt="BroBizee Logo"
            className="brand-logo-img"
          />

          <span>
            Simple. Fast. Reliable.
          </span>

        </footer>


        {/* Language Popup */}

        {isPopupOpen && (

          <div
            className="language-popup-overlay"
            onClick={() => setIsPopupOpen(false)}
          >

            <div
              className="language-popup-card"
              onClick={(e) =>
                e.stopPropagation()
              }
            >

              <div className="popup-top">

                <div>

                  <span className="popup-small-title">
                    PREFERENCE
                  </span>

                  <h2 className="popup-title">
                    Choose language
                  </h2>

                </div>


                <button
                  type="button"
                  className="popup-close-btn"
                  onClick={() =>
                    setIsPopupOpen(false)
                  }
                  aria-label="Close"
                >

                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >

                    <path d="M6 6l12 12" />
                    <path d="M18 6L6 18" />

                  </svg>

                </button>

              </div>


              <p className="popup-description">

                Select the language you are most comfortable
                using with BroBizee.

              </p>


              <div className="language-grid">

                {LANGUAGES_DATA.map((langItem) => (

                  <button
                    type="button"
                    key={langItem.id}
                    className={`lang-card ${
                      selectedLanguage.id === langItem.id
                        ? 'active-card'
                        : ''
                    }`}
                    style={{
                      '--card-color': langItem.color
                    }}
                    onClick={() =>
                      handleSelectLanguage(langItem)
                    }
                  >

                    <span className="lang-native">
                      {langItem.native}
                    </span>

                    <span className="lang-label">
                      {langItem.label}
                    </span>


                    {selectedLanguage.id === langItem.id && (

                      <span className="selected-check">
                        ✓
                      </span>

                    )}

                  </button>

                ))}

              </div>


              <div className="popup-footer">

                <img
                  src="/images/logo.png"
                  alt="BroBizee Logo"
                  className="brand-logo-img"
                />

              </div>

            </div>

          </div>

        )}

      </div>

    </div>
  );
}